/**
 * The frame the app sits in: a fixed-width column, so on a phone it fills the
 * screen and on a laptop it looks like what it is rather than a form stretched
 * across 1400 pixels.
 *
 * It used to draw court markings behind the content — one rule under the
 * header, two verticals near the edges — taken from `prototype/index.html`.
 * They are gone. `prototype/live-session.html`, which is the mockup the club
 * actually compares against, has never had them, and behind real content they
 * did not read as a court: they read as a second box drawn inside the first,
 * with a stray line cutting under the header. Ornament that has to be explained
 * is not working.
 */
export function Frame({ children }: { children: React.ReactNode }): React.JSX.Element {
  return <div className="phone">{children}</div>;
}

/**
 * The way to the backup tracker, and — from the backup tracker — back here.
 *
 * Under a home-screen install there is no address bar, so a member who needs
 * the paper-equivalent has no way to reach it and no way back. That is exactly
 * the situation the backup exists for, which made it the one link the app
 * could least afford to leave out.
 *
 * Deliberately a plain anchor rather than anything the service worker routes:
 * /backup/ is served off disk by nginx and must keep working when the app
 * itself does not.
 */
export function BackupLink({ note }: { note?: string }): React.JSX.Element {
  return (
    <a className="escape-hatch" href="/backup/">
      <span>Open the backup tracker</span>
      <span>{note ?? "works without the app"}</span>
    </a>
  );
}
